import type {FunctionComponent} from "react";
import {CheckCircleOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import ToastContent from "../../index";

export interface ISuccessToastContent {
    message: string,
    title?: string,
}

const SuccessToastContent: FunctionComponent<ToastContentProps<ISuccessToastContent>> = (props) => {

    return (
        <>
            <ToastContent
                title={props.data.title}
                message={props.data?.message ?? ''}
                icon={<CheckCircleOutlined color={'success'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default SuccessToastContent;
